import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of, take, tap } from 'rxjs';
import { CmsData, CmsResponse, ReportOptionsResponse } from '../models/cmsResponse';
import { FaqData, FaqResponse } from '../models/faqResponse';
import { environment } from '../../../environments/environment';
import { GuestResponse } from '../models/guestResponse';
import { GuestEndpoints } from '../const/guestEndpoints.const';

@Injectable({
  providedIn: 'root'
})
export class CmsService {
  public data!: CmsData;

  constructor(private readonly httpClient: HttpClient) {}

  public get cmsData$(): Observable<CmsData> {
    return this.data ? of(this.data) : this.getCmsData();
  }

  private getCmsData(): Observable<CmsData> {
    return this.httpClient
      .get<CmsResponse>(`${environment.base_url}getCms`)
      .pipe(
        take(1),
        map(res => res.data),
        tap(res => this.data = res)
      );
  }

  public getFaqData(): Observable<FaqData[]> {
    return this.httpClient
      .get<FaqResponse>(`${environment.base_url}getFaq`)
      .pipe(map(res => res.data));
  }

  getInfoForGuest(infoType: typeof GuestEndpoints[keyof typeof GuestEndpoints]): Observable<GuestResponse> {
    return this.httpClient.get<GuestResponse>(`${environment.guest_url}get-info/${infoType}`);
  }

  getReportReasons(): Observable<ReportOptionsResponse> {
    return this.httpClient.get<ReportOptionsResponse>(`${environment.base_url}get-info/reportPropertyList`);
  }
}
